import {
    MAPSEARCH_DELETE_MAPSEARCH
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

import {
    DeleteMapSearchParameters,
    DeleteMapSearchResult
} from '~/shared/src/utilities/modules/map';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';
import xhr from '~/frontend/src/utilities/xhr';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {number} mapSearchId
 * @param {( responseData : DeleteMapSearchResult ) => void} [successCallback]
 *
 * @return {Promise<DeleteMapSearchResult | false>}
 */
const deleteMapSearch = ( panelKey : string, mapSearchId : number, successCallback? : ( responseData : DeleteMapSearchResult ) => void ) : Thunk<Promise<DeleteMapSearchResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<DeleteMapSearchResult | false> => {
    dispatch( {
        type: MAPSEARCH_DELETE_MAPSEARCH,
        panelKey,
        mapSearchId
    } );

    let retVal : DeleteMapSearchResult | false = false;

    dispatch( clearElusiveData( panelKey ) );

    const params : DeleteMapSearchParameters = {
              viewId: mapSearchId
          },
          response                           = await xhr.post(
              `${BASE_URL}/api/map/deleteMapSearch`,
              params,
              undefined,
              panelKey,
              'deleteMapSearch',
              dispatch
          );

    if ( response?.data.success && !response.data.errorTitle ) {
        if ( successCallback ) {
            successCallback( response.data as DeleteMapSearchResult );
        }

        retVal = response.data as DeleteMapSearchResult;
    }

    return retVal;
};
export type DeleteMapSearch = typeof deleteMapSearch;

export default deleteMapSearch;
